var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"window-1"}},[_c('div',{staticClass:"top-text"},[_c('h1',[_vm._v("Survey Submitted!")]),_c('h3',[_vm._v("Thank you for filling out our setup survey. We're looking forward to building your plans with you soon!")])])])
}]

export { render, staticRenderFns }